import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import { saveHasManyRelationships } from 'umg-ember-backend/utils/model-save-hooks';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  headline: validator('presence', true),
  tracks: [validator('has-many'), validator('presence', true)],
});

export const settings = {
  saveHooks: {
    after: [saveHasManyRelationships('audioplayerShops', 'tracks')],
  },
};

export default class AudioplayerModel extends Model.extend(Validations) {
  // Attrviutes
  @attr('string') headline;
  @attr('string') subHeadline;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relation
  @hasMany('audioplayer-shop', { async: true, inverse: 'audioplayer' })
  audioplayerShops;
  @hasMany('audioplayer-track', { async: true, inverse: 'audioplayer' }) tracks;
  @belongsTo('asset', { async: true, inverse: null }) cover;
  @belongsTo('artist', { async: true, inverse: null }) artist;

  // Getter and setter
  get displayHeadline() {
    return this.headline;
  }

  get displayLabel() {
    return `${this.headline} (${this.id})`;
  }
}
